import styled from "styled-components";

export const MenuWrapper = styled.div`
  --menu-option-bottom-margin: 4px;
  --menu-option-bottom-margin-last: 4px;
  .menu-option__container {
    height: 36px;
  }
  .menu-option__in {
    padding-left: 12px;
  }

  .tooltip-info-icon {
    cursor: pointer;
  }

  .trigger-help-tooltip {
    opacity: 0;
    transition: 200ms ease-in;
  }

  .menu-option:hover {
    .trigger-help-tooltip {
      opacity: 1;
    }
  }
`;

export const IntegrationTitle = styled.div<Partial<{ pt: number; pb: number }>>`
  padding: ${(props) => props.pt ?? 0}px 10px ${(props) => props.pb ?? 6}px;
  display: flex;
  font-size: 0;

  .icon {
    margin-left: 5px;
  }
`;
